import { render } from "./Visitor.vue?vue&type=template&id=025c906c"
import script from "./Visitor.vue?vue&type=script&lang=js"
export * from "./Visitor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aron/Herd/de-veense-veiling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__